/**
 * 回傳修改語系後的網址
 * @param originalPath 原始路徑，例如 '/en-us/help/contact-us'
 * @param newLocale 新的語系代碼，例如 'en-int'
 * @returns 替換後的路徑，例如 '/en-int/help/contact-us'
 */

const replaceLocaleInPath = (
  originalPath: string,
  newLocale: string
): string => {
  const runtimeConfig = useRuntimeConfig();
  const { CONFIGURATION } = runtimeConfig.public;

  if (originalPath === '/') {
    if (CONFIGURATION === 'ACN') {
      return `/${newLocale}/marketplace`;
    }
    return `/${newLocale}`;
  }

  const pathSegments = originalPath.split('/');
  let result = '';

  if (pathSegments.length > 1 && pathSegments[0] === '') {
    pathSegments[1] = newLocale;
    result = pathSegments.join('/');
  } else {
    result = `/${newLocale}/${originalPath}`;
  }

  if (result.slice(-1) === '/') {
    return result.slice(0, -1);
  }
  return result;
};

export default replaceLocaleInPath;
